import React from 'react';
import { I18n } from '@aws-amplify/core';
import { DrawerForm } from './Form';
import { Drawer } from '@/components/ui/Drawer';
import { useDataExtractionReport } from '@/context/DataExtractionReport';

interface DrawerFilterProps {
	open?: boolean;
	onSubmit: () => void;
	onClear: () => void;
	onClose: () => void;
}

export function DrawerFilter({ open = false, onSubmit, onClear, onClose }: Readonly<DrawerFilterProps>) {
	const { gutterLayout } = useDataExtractionReport();

	return (
		<Drawer
			open={open}
			onClose={onClose}
			onClear={onClear}
			onSubmit={onSubmit}
			gutter={gutterLayout}
			title={I18n.get('Filter')}
		>
			<DrawerForm />
		</Drawer>
	);
}
